// Useful in forms where if not a number is entered then store null.
export const convertToInteger = (value) => {
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? null : parsed;
};

export const convertToFloat = (value) => {
  const parsed = parseFloat(value);
  return isNaN(parsed) ? null : parsed;
};

// toFixed converts the result to string and also does not work in some cases.
// If we want to round and keep it as float use this method.
export const roundToTwoDecimals = (number) =>
  Number(Math.round(number + 'e2') + 'e-2');
